<div class="add__action__form__content__message mb-3">
    <label for="message" class="input-label">Message</label>
    <textarea pInputTextarea [formControl]="message" [rows]="2" [style]="{width: '100%'}"></textarea>
    @if(message.errors?.minlength) {
    <idel-form-error [errorMessage]="'Le message doit contenir au moins 5 caractères.'"></idel-form-error>
    }
</div>

<i-tabs [items]="recipientsTabs()" (tabChange)="onActiveTabChange($event)"></i-tabs>
<div>
    <div>
        <div class="col-md-12" *ngIf="destinatairesNamePresent">
            <div class="alert alert-primary">
                Destinataire(s) déjà présent(s) dans la fiche courrier ({{recipientsNames.length}})
                <div>
                    {{destinatairesNamePresent}}
                </div>
            </div>
        </div>
        <section class="panel-content col-md-12">
            @if(activeRecipientTab() !== 'freeRecipients') {
            <div>
                <div class="my-3">
                    <i-button id="addContactRecipientModal" text="Ajouter un contact" styleClass="green" size="small"
                        (click)="openNewContact()"></i-button>
                </div>

                <div style="height: 50dvh; overflow-y: auto;">
                    @if(activeRecipientTab() ==='users') {
                    <idel-checkable-list [(items)]="users" [itemLabel]="['nom', 'prenom']"
                        (onCheck)="onRecipientCheck($event)"></idel-checkable-list>
                    }
                    @if(activeRecipientTab() === 'groups') {
                    <idel-checkable-list [(items)]="groups" [itemLabel]="'description'"
                        (onCheck)="onRecipientCheck($event)"></idel-checkable-list>
                    }
                    @if(activeRecipientTab() === 'services') {
                    <idel-checkable-list [(items)]="services" [itemLabel]="'description'"
                        (onCheck)="onRecipientCheck($event)"></idel-checkable-list>
                    }
                </div>
            </div>
            }@else {
            <div class="py-2">
                <label for="addFreeRecipientInput " class="super-compos-section-h4 ms-2 ">Destinataire
                    libre</label>
                <div class="alert alert-primary">
                    Encodez les destinataires séparées par un point virgule.
                </div>
                <div class="row">
                    <div class="col-md-12 mb-4">
                        <textarea id="textareaFreeRecipient" class="super-compos-default-btn-noshadow form-control"
                            [(ngModel)]="freeRecipient"></textarea>
                    </div>
                    <div class="col-md-12 d-flex align-items-center justify-content-center">
                        <i-button id="buttonValidateAddFreeRecipient" styleClass="blue" text="Valider les destinataires"
                            (click)="addRecipientFree()"></i-button>
                    </div>

                </div>
                <app-super-list-simple *ngIf="tabNewRecipient && tabNewRecipient.length> 0"
                    [items]="tabNewRecipient | sort:'name':'ASC' " [columns]="col " alignLast="right "
                    [boolShowHeader]="false" [boolMultiSelect]="true" (multiSelectValue)="onRecipientCheck($event) "
                    [boolImageMode]="true " icon="icon-start-full" [deletable]="true">
                </app-super-list-simple>

            </div>

            }
        </section>
    </div>
</div>
<div class="d-flex align-items-center justify-content-end">
    <i-button (click)="closeActionModal();" text="Annuler" styleClass="me-3 red">
    </i-button>
    <i-button id="buttonAddUsersRecipient" (click)="addUsers();"
        [text]="getTttlRecipientsToAdd() > 0 ? 'Ajouter ' + getTttlRecipientsToAdd() + ' destinataires' : 'Sélectionner des destinataires'"
        styleClass="green" [disabled]="getTttlRecipientsToAdd() === 0">
    </i-button>
</div>